module.exports = __webpack_public_path__ + "media/fr_fr_s2_Maurice.96782cd7.mp3";